<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-users" /> Importação de Pessoas
        </h2>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Enviar planilha do Excel (.xlsx):</label>
          <input
            ref="fileInput"
            type="file"
            class="form-control-file"
            @change="onFileSelected($event)"
          />
        </div>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success" @click="upload">Enviar</button>
      </div>
    </div>
    <hr />
    <button class="btn btn-success" @click="store">Importar</button>
    <div class="row">
      <div class="col-md-12 mt-5">
        <table class="table">
          <tr>
            <th v-for="column in columns">{{ column.label }}</th>
          </tr>
          <template v-for="(row, index) in persons">
            <tr :key="index">
              <td v-for="column in columns">{{ row[column.key] }}</td>
              <td>
                <span v-if="isRowValid(row)">Ok</span>
                <span v-else>Erro</span>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters.js";

export default {
  components: {},

  data: function () {
    return {
      form: {},

      persons: [],

      columns: [
        { key: "A", label: "Código" },
        { key: "B", label: "Cliente" },
        { key: "C", label: "Fornecedor" },
        { key: "D", label: "Vendedor" },
        { key: "E", label: "Transportadora" },
        { key: "F", label: "Nome" },
        { key: "G", label: "Limite de Crédito" },
        { key: "H", label: "Data de Nascimento" },
        { key: "I", label: "Nome da Mãe" },
        { key: "J", label: "CPF" },
        { key: "K", label: "RG" },
        { key: "L", label: "CNPJ" },
        { key: "M", label: "IE" },
        { key: "N", label: "IM" },
        { key: "O", label: "Whatsapp" },
        { key: "P", label: "Telefone" },
        { key: "Q", label: "Telefone" },
        { key: "R", label: "Telefone" },
        { key: "S", label: "Email" },
        { key: "T", label: "Email" },
        { key: "U", label: "Email" },
        { key: "V", label: "Endereço" },
        { key: "W", label: "Número" },
        { key: "X", label: "Complemento" },
        { key: "Y", label: "Bairro" },
        { key: "Z", label: "Cep" },
        { key: "AA", label: "Cidade" },
        { key: "AB", label: "UF" },
        { key: "AC", label: "Observações" },
      ],
    };
  },

  created() {
    //this.$store.commit('pageHasLoaded')
    this.$store.commit("pageHasLoaded");
    // axios
    //   .post("../../api/billpayable/import/loaddata")
    //   .then(response => {
    //     // this.bills        = response.data.bills
    //     // this.account_plan = response.data.accountPlan;
    //     this.bills = response.data[0];
    //     console.log(response.data);
    //   })
    //   .catch(error => {
    //     this.error = error;
    //   });
  },

  methods: {
    isRowValid(row) {
      if (row.C == null) {
        return false;
      }

      return true;
    },

    onFileSelected(event) {
      console.log(event);
      this.form.file = event.target.files[0];
    },

    upload() {
      this.$store.commit("showLoading");

      let form = new FormData();
      form.append("file", this.form.file, "file");

      axios
        .post("./../api/person/import", form)
        .then((response) => {
          console.log(response.data);
          this.persons = response.data;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },

    store() {
      this.$store.commit("showLoading");

      axios
        .post("./../api/person/storeimport", this.persons)
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>

